import { render, staticRenderFns } from "./infoCollectionDc.vue?vue&type=template&id=62a9ff3f"
import script from "./infoCollectionDc.vue?vue&type=script&lang=js"
export * from "./infoCollectionDc.vue?vue&type=script&lang=js"
import style0 from "./infoCollectionDc.vue?vue&type=style&index=0&id=62a9ff3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports